<script setup>
import { computed } from 'vue'
import { useAuth } from '@/Hooks/Company/useAuth.js'
import { pluralize } from '@/Utils/StringFormatter.js'
import { TextButton } from '@aryeo/runway'
import { router } from '@inertiajs/vue3'
import SystemAlert from '@/Runway/Alerts/SystemAlert.vue'

const { authCompanyUser, passwordExpirationReminderDays } = useAuth()

const showBanner = computed(
  () =>
    authCompanyUser.value?.password_expiration_days !== null &&
    authCompanyUser.value?.password_expiration_days <= passwordExpirationReminderDays.value
)
</script>

<template>
  <SystemAlert
    v-if="showBanner"
    identifier="password-expiration-banner"
    :description="`Your password will expire in ${authCompanyUser.password_expiration_days} ${pluralize(authCompanyUser.password_expiration_days, 'day', 'days')}.`"
    variant="warning"
  >
    <template #actions>
      <TextButton
        text="Change Password"
        color="white"
        @click="router.visit(route('web.company.auth-company-user.show'))"
      />
    </template>
  </SystemAlert>
</template>
